// extracted by mini-css-extract-plugin
export default {"container":"BorderTrail_container__0XH2O","svgOverlay":"BorderTrail_svgOverlay__OVEyc","trail":"BorderTrail_trail__DsTNP","moveTrail":"BorderTrail_moveTrail__FXqdC"};